import Enum from "./Enum";

export default Enum.create( {
	REQUESTED: "REQUESTED",
	REQUESTED_RETRY: "REQUESTED_RETRY",
	QUEUED: "QUEUED",
	COMMITTED: "COMMITTED",
	SUMMARIZED: "SUMMARIZED",
	FINISHED: "FINISHED",
	ABORTED: "ABORTED",
	FAILED: "FAILED",
} );
